module.exports = __webpack_public_path__ + "static/media/inkandtimecomingsoon.1b4059f8.png";